import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { SelectItem } from 'primeng/api';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-route-queue-modal',
    templateUrl: './route-queue-modal.component.html',
    styleUrls: ['./route-queue-modal.component.scss'],
    standalone: false
})
export class RouteQueueDialogComponent {
  @Input() currentUser: SelectItem;
  @Input() users: SelectItem[];
  @Input() isVisible: boolean;
  @Input() isLoading: boolean;

  @Output() closeDialog = new EventEmitter<void>();
  @Output() submitRoute = new EventEmitter<string>();

  selectedUserId: string;

  onClose(): void {
    this.isVisible = false;
    this.closeDialog.emit();
  }

  onSubmit() {
    this.submitRoute.emit(this.selectedUserId);
  }
}
